function resetPlugin({ store }) {
  const initialState = JSON.parse(JSON.stringify(store.$state))

  store.$reset = () => {
    store.$patch(initialState)
  }
}

export default resetPlugin
